import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { WizDateUtils } from '@wizeoo/akm-core-lib';
import { IWizItemRenderer, WizImage, WizEventManager } from '@wizeoo/akm-component-lib';
import { BaseTileRenderer } from '@wizeoo/akm-common-lib';
import { FreeDataVO } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { FreedataLevelVO } from '@wizeoo/akm-common-lib';
import { FreedataValueVO } from '@wizeoo/akm-common-lib';

/**
 * Vignette de présentation d'un rôle pour l'affichage en mode vignette du MultiDisplay
 */

@Component({
  selector: 'md-freedata-tile-renderer',
  templateUrl: './md-freedata-tile.renderer.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MdFreedataTileRenderer implements IWizItemRenderer<null, FreeDataVO> {
  @ViewChild('mdFreedataTileRenderer', { read: BaseTileRenderer, static: true })
  mdTileRenderer: BaseTileRenderer;

  @ViewChild('imgFd', { read: WizImage, static: true })
  imgFd: WizImage;

  constructor(public elementRef: ElementRef) {}

  // Le VO manipulé
  private _data: FreeDataVO;
  public get data(): FreeDataVO {
    return this._data;
  }
  public set data(data: FreeDataVO) {
    this._data = data;
    // this.imgFd.sourceObservable = this._data.iconOrDie;
    this.mdTileRenderer.data = data;
  }

  public get isMultiLevel(): boolean {
    return this.data?.levelsVO?.length > 1;
  }

  public get isFormula(): boolean {
    return this.data?.kindMeasure;
  }

  public get isWild(): boolean {
    return this.data?.kindWild;
  }

  // Le titre complémentaire est une concaténation des dates de début et de fin de validité
  public get startEndDate(): string {
    let result: string;
    const startDateStr: string = WizDateUtils.numberToLocalizedString(this.data.startDate);
    if (startDateStr !== undefined) {
      result = startDateStr + ' - ' + WizDateUtils.numberToLocalizedString(this.data.endDate);
    }
    return result;
  }

  // Si structure hiérarchique, les libellés des niveaux
  // Si énuméré, la liste exhautive des éléments
  public get elements(): string {
    let result: string;
    const levels: FreedataLevelVO[] = this._data.levelsVO;

    if (levels.length > 1) {
      for (let i = 0; i < levels.length; i++) {
        if (i === 0) {
          result = levels[i].trsLabel;
        } else {
          result = result + ' > ' + levels[i].trsLabel;
        }
      }
    } else {
      const values: FreedataValueVO[] = this._data.getValuesVO();
      const maxIt: number = Math.min(values.length, 4);
      for (let i = 0; i < maxIt; i++) {
        if (i === 0) {
          result = values[i].trsLabel;
        } else {
          if (i < values.length) {
            result = result + '<br/>' + values[i].trsLabel;
          }
        }
      }
    }
    if (!result) {
      result = ' '; // sinon pas de refresh sur le libellé
    }
    return result;
  }

  /** Dispatch du clic sur le bouton de duplication de la codification */
  public onDuplicate(e: Event): void {
    e.stopImmediatePropagation();
    e.preventDefault();
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.DUPLICATE_DATA, this._data, this));
  }

}
